<!-- Translated: yes -->
<template>
  <div :class="{cart: true, showing: showing, 'from-start': showFromStart, 'remote': !useStorage}" :style="showFromStart ? 'position:static;' : ''">
    <div v-if="showing && localCart.accomodations">

      <div v-if="!useStorage">
        <div v-if="localCart.rows.accomodation && localCart.rows.accomodation.length">
          <header class="category-header">
            <div class="col">{{ $t('general.accomodation') }}</div>
          </header>
          <div v-for="(row, index) in localCart.rows.accomodation" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.accommodation ? (row.accommodation.display_name || row.accommodation.description_title) : row.name}}</span>
              <div v-if="row.accommodation && row.accommodation.subtitle" style="margin-top:2px;margin-bottom:8px;font-weight:300;">
                {{row.accommodation.subtitle}}
              </div>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="SITE_CONFIG.add_to_booking_open && localCart.can_add_to_booking">
              <button class="small white border" @click="bookAddon(row)">Boka tillval</button>
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <div v-if="localCart.rows.addon && localCart.rows.addon.length">
          <div v-for="(row, index) in localCart.rows.addon" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.name}}</span>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="row.quantity != 1">
              {{row.quantity}} {{ $t('general.pieces-short') }}
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <div v-if="localCart.rows.skipass && localCart.rows.skipass.length">
          <header class="category-header">
            <div class="col">{{ $t('general.skipass') }}</div>
          </header>
          <div v-for="(row, index) in localCart.rows.skipass" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.rental ? row.rental.name : row.name}}, {{row.age_text}}</span>
              <div style="margin-top:2px;margin-bottom:8px;font-weight:300;">
                {{ row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup }}
              </div>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="row.quantity != 1">
              {{row.quantity}} {{ $t('general.pieces-short') }}
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <div v-if="localCart.rows.rental && localCart.rows.rental.length">
          <header class="category-header">
            <div class="col">{{ $t('general.equipment') }}</div>
          </header>
          <div v-for="(row, index) in localCart.rows.rental" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.rental ? row.rental.name : row.name}}{{row.age_text ? ', ' + row.age_text : ''}}</span>
              <div style="margin-top:2px;margin-bottom:8px;font-weight:300;">
                {{ row.pickup === 'DELIVERY' ? 'Utkörning' : row.pickup }}
              </div>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="row.quantity != 1">
              {{row.quantity}} {{ $t('general.pieces-short') }}
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <div v-if="localCart.rows.skischool && localCart.rows.skischool.length">
          <header class="category-header">
            <div class="col">{{ $t('general.school') }}</div>
          </header>
          <div v-for="(row, index) in localCart.rows['skischool']" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.name }}</span>
              <div style="margin-top:8px;margin-bottom:8px;">
                <button class="small white border" @click="rowInfo(row)">Info</button>
              </div>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="row.quantity != 1">
              {{row.quantity}} {{ $t('general.pieces-short') }}
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <div v-if="localCart.rows.other && localCart.rows.other.length">
          <header class="category-header">
            <div class="col">Övrigt</div>
          </header>
          <div v-for="(row, index) in localCart.rows['other']" :class="'row ' + (row.cancelled ? 'cancelled' : '')">
            <div class="col type">
              <span>{{row.name }}</span>
              <div style="margin-top:2px;margin-bottom:8px;font-weight:300;">
              </div>
            </div>
            <div class="col date">
              <icon name="calendar-blue" :scale="1.5" />
              {{ [row.date_arrival, row.date_departure] | dateRange('D MMMM', ' - ') | capitalize }}
            </div>
            <div class="col count" v-if="row.quantity != 1">
              {{row.quantity}} {{ $t('general.pieces-short') }}
            </div>
            <div class="col count" v-else>
              &nbsp;
            </div>
            <div class="col price">
              {{(row.quantity * row.price) | currency}}
            </div>
          </div>
        </div>

        <footer>
          <div class="col"><b>{{ $t('general.sum') }}</b></div>
          <div class="col">{{ $t('general.total-neutrum') }}: {{localCart.sum | currency}}</div>
        </footer>
      </div>

      <div v-if="useStorage">

      <!-- Accomodations -->
      <header class="category-header" v-if="localCart.accomodations.filter(function(object) { return object.confirmed; }).length || localCart.addons.filter(function(object) { return object.confirmed; }).length">
        <div class="col">{{ $t('general.accomodation') }}</div>
      </header>

      <div v-for="(accomodation, index) in localCart.accomodations" v-if="accomodation.confirmed" class="row">
        <div class="col type">
          {{accomodation.name}}
        </div>
        <div class="col date">
          <icon name="calendar-blue" :scale="1.5" />
          {{moment(accomodation.period.date_arrival, 'dddd')}} - {{moment(accomodation.period.date_departure, 'dddd')}}
          &nbsp; &nbsp;
          {{moment(accomodation.period.date_arrival, 'D MMMM')}} - {{moment(accomodation.period.date_departure, 'D MMMM')}}
        </div>
        <div :class="'col count hide-on-small'">
          &nbsp;
          <!--<span class="label">Antal:</span> {{accomodation.quantity}} st-->
        </div>
        <div class="col actions">
          <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
          <!--<button class="small white border" v-if="useStorage" @click="edit({type: 'accomodations', index: index})"><icon name="edit-blue" /> Ändra</button>-->
        </div>
        <div class="col price" v-if="cart.campaignCode">
          <PriceView
            :price="number(accomodation.quantity) * number(accomodation.price)"
            :discounted="accomodationDiscountedPrice(accomodation)"
            />
        </div>
        <div class="col price" v-if="!cart.campaignCode">
          {{(number(accomodation.quantity) * number(accomodation.price)) | currency}}
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'accomodations', index: index})"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!accomodation.allow_cancellation" @click="cancel({row: accomodation.row, type: 'accomodations', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <div v-for="(addon, index) in localCart.addons" v-if="addon.confirmed && !addon.hide_for_guest" class="row">
        <div class="col type">
          {{addon.title}}
          <div class="thin" v-if="addon.belongsTo > -1 && localCart.accomodations.filter(function(a) {return a.confirmed;}).length > 1">{{localCart.accomodations[addon.belongsTo].name}}</div>
        </div>
        <div class="col date min-tablet">
          &nbsp;
        </div>
        <div :class="'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')" v-if="addon.editableQuantity || addon.quantity > 1">
          <span class="label">{{ $t('general.number') }}:</span>
          <span v-if="addon.editableQuantity">
            <input type="number" v-model="addon.quantity" /> {{ $t('general.pieces-short') }}
          </span>
          <span v-else>
            {{addon.quantity}} {{ $t('general.pieces-short') }}
          </span>
        </div>
        <div :class="'col count ' + (addon.quantity > 1 ? '' : 'hide-on-small')" v-else>
          &nbsp;
        </div>
        <div class="col actions">
          <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
          <!--<button class="small white border" v-if="useStorage" @click="edit({type: 'addons', index: addon.belongsTo})"><icon name="edit-blue" /> Ändra</button>-->
        </div>
        <div :class="'col price ' + (addon.discount ? 'has-discount' : '')">
          <PriceView
            :price="number(addon.quantity) * number(addon.price)"
            :discounted="addonDiscountedPrice(addon)"
            />
          <div v-if="addon.discount" class="discount">
            <div v-if="addon.discount.type === 'percentage' && addon.discount.code === 'rut'">
              {{ $t('accomodation.cleaning-tax-reduction') }}: -{{
                ((number(addon.quantity) * number(addon.price)) * (addon.discount.amount / 100)) | currency
              }}
            </div>
          </div>
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'addons', index: index})" v-if="!addon.locked"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!addon.allow_cancellation" @click="cancel({row: addon.row, type: 'addons', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <!-- Skipasses -->
      <header class="category-header" v-if="
        localCart.skipasses.filter(function(object) { return object.confirmed && (parseInt(object.adults) || parseInt(object.youths) || parseInt(object.children) || parseInt(object.seniors)); }).length
        ||
        localCart.skipasses.filter(function(object) { return object.confirmed && object.type === ''; }).length
        ">
        <div class="col">{{ $t('general.skipass') }}</div>
      </header>

      <div v-for="(skipass, index) in localCart.skipasses" v-if="skipass.confirmed && skipass.type === 'SKIPASS-ACCO'">

        <div class="row" v-if="!skipass.hideadults">
          <div class="col type">
            {{skipass.days}} {{ $t('general.days') }} / {{ $t('general.ages.adult') }}
            <div class="thin" v-if="skipass.belongsTo > -1 && localCart.accomodations.filter(function(a) {return a.confirmed;}).length > 1">{{localCart.accomodations[skipass.belongsTo].name}}</div>
            <!-- <div class="thin" v-if="skipass.delivery || skipass.delivery_type === 'delivery'">Utkörning</div> -->
          </div>
          <div class="col date min-tablet">
            &nbsp;
          </div>
          <div class="col count">
            <span class="label">{{ $t('general.number') }}: </span>
            <input type="number" v-model="skipass.adults" /> {{ $t('general.pieces-short') }}
          </div>
          <div class="col actions">
            <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
            <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
          </div>
          <div class="col price" v-if="cart.campaignCode">
            <PriceView
              :price="number(skipass.adults) * number(skipass.adultsPrice)"
              :discounted="accomodationSkipassDiscountedPrice(skipass, 'adult', 'adults')"
              />
          </div>
          <div class="col price" v-if="!cart.campaignCode">
            {{(number(skipass.adults) * number(skipass.adultsPrice)) | currency}}
          </div>
          <div class="col trash" v-if="useStorage">
            <button class="small trash border" @click="localRemoveCartItem({type: 'skipasses', index: index, age: 'adults'})"><icon name="trash" :scale="1.5" /></button>
          </div>
          <div v-else>
            <!--<button :disabled="!skipass.allow_cancellation" @click="cancel({row: skipass.row, type: 'skipasses', index: index})" class="small white border">Avboka</button>-->
          </div>
        </div>

        <div class="row" v-if="!skipass.hideseniors">
          <div class="col type">
            {{skipass.days}} {{ $t('general.days') }} / {{ $t('general.ages.senior') }}
            <div class="thin" v-if="skipass.belongsTo > -1 && localCart.accomodations.filter(function(a) {return a.confirmed;}).length > 1">{{localCart.accomodations[skipass.belongsTo].name}}</div>
            <!-- <div class="thin" v-if="skipass.delivery || skipass.delivery_type === 'delivery'">Utkörning</div> -->
          </div>
          <div class="col date min-tablet">
            &nbsp;
          </div>
          <div class="col count">
            <span class="label">{{ $t('general.number') }}: </span>
            <input type="number" v-model="skipass.seniors" /> {{ $t('general.pieces-short') }}
          </div>
          <div class="col actions">
            <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
            <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
          </div>
          <div class="col price" v-if="cart.campaignCode">
            <PriceView
              :price="number(skipass.seniors) * number(skipass.seniorsPrice)"
              :discounted="accomodationSkipassDiscountedPrice(skipass, 'senior', 'seniors')"
              />
          </div>
          <div class="col price" v-if="!cart.campaignCode">
            {{(number(skipass.seniors) * number(skipass.seniorsPrice)) | currency}}
          </div>
          <div class="col trash" v-if="useStorage">
            <button class="small trash border" @click="localRemoveCartItem({type: 'skipasses', index: index, age: 'seniors'})"><icon name="trash" :scale="1.5" /></button>
          </div>
          <div v-else>
            <!--<button :disabled="!skipass.allow_cancellation" @click="cancel({row: skipass.row, type: 'skipasses', index: index})" class="small white border">Avboka</button>-->
          </div>
        </div>

        <div class="row" v-if="!skipass.hideyouths">
          <div class="col type">
            {{skipass.days}} {{ $t('general.days') }} / {{ $t('general.ages.youth') }}
            <div class="thin" v-if="skipass.belongsTo > -1 && localCart.accomodations.filter(function(a) {return a.confirmed;}).length > 1">{{localCart.accomodations[skipass.belongsTo].name}}</div>
            <!-- <div class="thin" v-if="skipass.delivery || skipass.delivery_type === 'delivery'">Utkörning</div> -->
          </div>
          <div class="col date min-tablet">
            &nbsp;
          </div>
          <div class="col count">
            <span class="label">{{ $t('general.number') }}: </span>
            <input type="number" v-model="skipass.youths" /> {{ $t('general.pieces-short') }}
          </div>
          <div class="col actions">
            <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
            <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
          </div>
          <div class="col price" v-if="cart.campaignCode">
            <PriceView
              :price="number(skipass.youths) * number(skipass.youthsPrice)"
              :discounted="accomodationSkipassDiscountedPrice(skipass, 'youth', 'youths')"
              />
          </div>
          <div class="col price" v-if="!cart.campaignCode">
            {{(number(skipass.youths) * number(skipass.youthsPrice)) | currency}}
          </div>
          <div class="col trash" v-if="useStorage">
            <button class="small trash border" @click="localRemoveCartItem({type: 'skipasses', index: index, age: 'youths'})"><icon name="trash" :scale="1.5" /></button>
          </div>
          <div v-else>
            <!--<button :disabled="!skipass.allow_cancellation" @click="cancel({row: skipass.row, type: 'skipasses', index: index})" class="small white border">Avboka</button>-->
          </div>
        </div>

        <div class="row" v-if="!skipass.hidechildren">
          <div class="col type">
            {{skipass.days}} {{ $t('general.days') }} / {{ $t('general.child') }}
            <div class="thin" v-if="skipass.belongsTo > -1 && localCart.accomodations.filter(function(a) {return a.confirmed;}).length > 1">{{localCart.accomodations[skipass.belongsTo].name}}</div>
            <!-- <div class="thin" v-if="skipass.delivery || skipass.delivery_type === 'delivery'">Utkörning</div> -->
          </div>
          <div class="col date min-tablet">
            &nbsp;
          </div>
          <div class="col count">
            <span class="label">{{ $t('general.number') }}: </span>
            <input type="number" v-model="skipass.children" /> {{ $t('general.pieces-short') }}
          </div>
          <div class="col actions">
            <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
            <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
          </div>
          <div class="col price" v-if="cart.campaignCode">
            <PriceView
              :price="number(skipass.children) * number(skipass.childrenPrice)"
              :discounted="accomodationSkipassDiscountedPrice(skipass, 'child', 'children')"
              />
          </div>
          <div class="col price" v-if="!cart.campaignCode">
            {{(number(skipass.children) * number(skipass.childrenPrice)) | currency({freeIfZero: true})}}
          </div>
          <div class="col trash" v-if="useStorage">
            <button class="small trash border" @click="localRemoveCartItem({type: 'skipasses', index: index, age: 'children'})"><icon name="trash" :scale="1.5" /></button>
          </div>
          <div v-else>
            <!--<button :disabled="!skipass.allow_cancellation" @click="cancel({row: skipass.row, type: 'skipasses', index: index})" class="small white border">Avboka</button>-->
          </div>
        </div>

      </div>

      <div>

        <div class="row"  v-for="(skipass, index) in localCart.skipasses" v-if="skipass.confirmed && (skipass.type === 'SKIPASS' || skipass.type === '')">
          <div class="col type">
            {{skipass.title}} / {{ {'children': $t('general.ages.child'), 'youths': $t('general.ages.youth'), 'adults': $t('general.ages.adult'), 'parents': $t('general.ages.parents'), 'seniors': $t('general.ages.senior')}[skipass.age] }}
            / {{skipass.refill ? $t('skipass.load') : (skipass.keycardPrice ? $t('skipass.with-keycard') : '')}}
            <!-- <div class="thin" v-if="skipass.delivery || skipass.deliveryType === 'delivery'">Utkörning</div> -->
          </div>
          <div class="col date">
            <icon name="calendar-blue" :scale="1.5" />
            {{moment(skipass.date_arrival, 'D MMMM')}}
          </div>
          <div class="col count">
            <span class="label">{{ $t('general.number') }}: </span>
            <input type="number" v-model="skipass.quantity" /> {{ $t('general.pieces-short') }}
          </div>
          <div class="col actions">
            <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
            <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
          </div>
          <div class="col price" v-if="cart.campaignCode">
            <PriceView
              :price="number(skipass.quantity) * (number(skipass.price) + ( skipass.keycardPrice ? number(skipass.keycardPrice) : 0 ) )"
              :discounted="skipass.discountedPrice && skipass.discountedPrice > 0 ? (number(skipass.quantity) * (number(skipass.discountedPrice) + ( skipass.keycardPrice ? number(skipass.keycardPrice) : 0 ) )) : ( skipass.keycardPrice ? number(skipass.keycardPrice) : 0 )"
              />
          </div>
          <div class="col price" v-if="!cart.campaignCode">
            {{(number(skipass.quantity) * (number(skipass.price) + ( skipass.keycardPrice ? number(skipass.keycardPrice) : 0 ) )) | currency}}
          </div>
          <div class="col trash" v-if="useStorage">
            <button class="small trash border" @click="localRemoveCartItem({type: 'skipasses', index: index})"><icon name="trash" :scale="1.5" /></button>
          </div>
          <div v-else>
            <!--<button :disabled="!skipass.allow_cancellation" @click="cancel({row: skipass.row, type: 'skipasses', index: index})" class="small white border">Avboka</button>-->
          </div>
        </div>

      </div>

      <!-- Rental -->
      <header class="category-header" v-if="localCart.rentals.filter(function(object) { return object.confirmed; }).length">
        <div class="col">{{ $t('general.equipment') }}</div>
      </header>

      <div v-for="(rental, index) in localCart.rentals" v-if="rental.confirmed" class="row">
        <div class="col type">
          {{rental.name}}<span v-if="rental.insurance"> ({{ $t('skirental.incl-insurance') }})</span>
          <ul v-if="rental.products || rental.addons">
            <li class="sub" v-for="product in rental.products">
              {{product.name}}
            </li>
            <li class="sub" v-for="product in rental.addons">
              {{product.name}}
            </li>
            <li class="sub" v-if="rental.insurance">
              {{ $t('skirental.insurance.text') }} <span v-if="!this.SITE_CONFIG.rental.insurance_per_product">({{rental.insuranceSum | currency}})</span>
            </li>
          </ul>
        </div>
        <div class="col date">
          <icon name="calendar-blue" :scale="1.5" />
          {{moment(rental.startDate, 'D MMMM')}}, {{(rental.priceType === 'night' && SITE_CONFIG.site !== 'vallasen') ? '' : rental.days}} {{
              (rental.priceType === 'night' ?
                ((SITE_CONFIG.site === 'vallasen' || SITE_CONFIG.site === 'kungsberget') ? $t('general.night') : $t('skirental.day-options.hours', { hours: SITE_CONFIG.rental.night_hours })) :
                (rental.days > 1 ? $t('general.days') : $t('general.day'))
              )
            }}
        </div>
        <div :class="'col count ' + (rental.quantity > 1 ? '' : 'hide-on-small')">
          &nbsp;
        </div>
        <div class="col actions">
          <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
          <!--<button class="small white border" v-if="useStorage" @click="edit({type: 'skirentals', index: index})"><icon name="edit-blue" /> Ändra</button>-->
        </div>
        <div class="col price" v-if="SITE_CONFIG.rental.insurance_per_product">
          <div v-if="localCart.campaignCode">
            <PriceView
              :price="getProductPrice(rental)"
              :discounted="getProductPrice(rental, true)"
              />
          </div>
          <div v-if="!localCart.campaignCode">
            {{(rental.quantity * rental.price) | currency}}
          </div>
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'rentals', index: index})"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!rental.allow_cancellation" @click="cancel({row: rental.row, type: 'rentals', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <!-- Delivery Fee product categorized under Equipment (Skidhyra) -->
      <div v-for="(product, index) in (localCart.products || [])" v-if="SITE_CONFIG.rental.delivery_fee_active && parseInt(product.poolId, 10) === parseInt(SITE_CONFIG.rental.delivery_fee_pool_lid, 10)" class="row">
        <div class="col type">
          {{product.name}}
          <div class="thin" style="font-weight: 300; font-size: 12px; margin-top: 4px;">Utkörning till {{(localCart.deliveryTo && localCart.deliveryTo.name) ? localCart.deliveryTo.name : 'ditt boende'}}</div>
        </div>
        <div class="col date">
        </div>
        <div :class="'col count ' + (product.quantity > 1 ? '' : 'hide-on-small')">
          <span v-if="product.quantity > 1">
            {{ product.quantity }} {{ $t('general.pieces-short') }}
          </span>
          <span v-else>
            &nbsp;
          </span>
        </div>
        <div class="col actions">
        </div>
        <div class="col price">
          {{(product.quantity * product.price) | currency}}
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="removeDelivery()"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
        </div>
      </div>

      <!-- School -->
      <header class="category-header" v-if="localCart.skischools.filter(function(object) { return true; }).length">
        <div class="col">{{ $t('general.school') }}</div>
      </header>

      <div v-for="(school, index) in localCart.skischools" class="row">
        <div class="col type">
          {{school.name}}
          <ul v-if="school.people.length">
            <li class="sub" v-for="person in school.people">
              {{person.name}}
            </li>
          </ul>
        </div>
        <div class="col date">
          <icon name="calendar-blue" :scale="1.5" />
          {{moment(school.date, 'D MMMM')}}, {{school.days}} {{ $t('general.days') }}, {{school.time}}
        </div>
        <div class="col count" v-if="school.quantity > 1">
          {{school.quantity}} {{ $t('general.pieces-short') }}
        </div>
        <div class="col count hide-on-small" v-else>
          &nbsp;
        </div>
        <div class="col actions">
          <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
          <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
        </div>
        <div class="col price">
          {{(school.quantity * school.price) | currency}}
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'skischools', index: index})"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!school.allow_cancellation" @click="cancel({row: school.row, type: 'skischools', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <!-- Activities -->
      <header class="category-header" v-if="(localCart.activities || []).filter(function(object) { return true; }).length">
        <div class="col">{{ $t('general.activities') }}</div>
      </header>

      <div v-for="(activity, index) in localCart.activities" class="row">
        <div class="col type">
          {{activity.name}}
          <ul v-if="activity.people.length">
            <li class="sub" v-for="person in activity.people">
              {{person.name}}
            </li>
          </ul>
        </div>
        <div class="col date">
          <icon name="calendar-blue" :scale="1.5" />
          {{moment(activity.date, 'D MMMM')}}, {{activity.days}} {{ $t('general.days') }}, {{activity.time}}
        </div>
        <div class="col count" v-if="activity.quantity > 1">
          {{activity.quantity}} {{ $t('general.pieces-short') }}
        </div>
        <div class="col count hide-on-small" v-else>
          &nbsp;
        </div>
        <div class="col actions">
          <!--<button class="small white border" disabled><icon name="info-blue" /> Info</button>-->
          <!--<button class="small white border" v-if="useStorage" disabled><icon name="edit-blue" /> Ändra</button>-->
        </div>
        <div class="col price">
          {{(activity.quantity * activity.price) | currency}}
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'activities', index: index})"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!activity.allow_cancellation" @click="cancel({row: activity.row, type: 'activities', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <!-- Products -->
      <header class="category-header" v-if="(localCart.products || []).filter(function(object) { return !SITE_CONFIG.rental.delivery_fee_active || parseInt(object.poolId, 10) !== parseInt(SITE_CONFIG.rental.delivery_fee_pool_lid, 10); }).length">
        <div class="col">Produkter</div>
      </header>

      <div v-for="(product, index) in (localCart.products || [])" v-if="!SITE_CONFIG.rental.delivery_fee_active || parseInt(product.poolId, 10) !== parseInt(SITE_CONFIG.rental.delivery_fee_pool_lid, 10)" class="row">
        <div class="col type">
          {{product.name}}
        </div>
        <div class="col date">
        </div>
        <div :class="'col count hide-on-small'">
          <span v-if="product.editableQuantity === false">
            {{ product.quantity }} {{ $t('general.pieces-short') }}
          </span>
          <span v-else>
            <input type="number" v-model="product.quantity" /> {{ $t('general.pieces-short') }}
          </span>
        </div>
        <div class="col actions">
        </div>
        <div class="col price">
          {{(product.quantity * product.price) | currency}}
        </div>
        <div class="col trash" v-if="useStorage">
          <button class="small trash border" @click="localRemoveCartItem({type: 'products', index: index})"><icon name="trash" :scale="1.5" /></button>
        </div>
        <div v-else>
          <!--<button :disabled="!accomodation.allow_cancellation" @click="cancel({row: accomodation.row, type: 'accomodations', index: index})" class="small white border">Avboka</button>-->
        </div>
      </div>

      <!-- Products -->
      <header class="category-header" v-if="hasDelivery && (!SITE_CONFIG.rental.delivery_fee_active || SITE_CONFIG.rental.delivery_fee_price <= 0 || localCart.parent_has_delivery_fee)">
        <div class="col">Utkörning</div>
      </header>

      <div class="row" v-if="hasDelivery && (!SITE_CONFIG.rental.delivery_fee_active || SITE_CONFIG.rental.delivery_fee_price <= 0 || localCart.parent_has_delivery_fee)">
        <div class="col type" style="margin-bottom:10px;">
          Utkörning till {{(localCart.deliveryTo && localCart.deliveryTo.name) ? localCart.deliveryTo.name : 'ditt boende'}}
        </div>
        <div class="col date">
        </div>
        <div :class="'col count hide-on-small'">
        </div>
        <div class="col actions">
        </div>
        <div class="col price">
          <span v-if="SITE_CONFIG.rental.delivery_fee_active && localCart.parent_has_delivery_fee"></span>
          <span v-else>{{0 | currency({freeIfZero: true})}}</span>
        </div>
        <div class="col trash">
          <button class="small trash border" @click="removeDelivery()"><icon name="trash" :scale="1.5" /></button>
        </div>
      </div>

      <footer>
        <div class="col"><b>{{ $t('general.sum') }}</b></div>
        <div class="col" v-if="cart.campaignCode" style="text-align:right;">{{ $t('general.total-neutrum') }}: 
          <PriceView
            :price="totalPrice(false)"
            :discounted="totalPrice(true)"
            />
        </div>
        <div class="col" v-if="!cart.campaignCode" style="text-align:right;">{{ $t('general.total-neutrum') }}: {{totalPrice() | currency}}</div>
      </footer>

      <div class="row" v-if="!showFromStart">
        <div class="col right">
          <button class="small light-blue" @click="closeCart()" style="margin-right: 15px;">{{ $t('general.continue-booking') }}</button>
          <button @click="pay()">{{ $t('general.to-checkout') }} <icon name="arrow-white" /></button>
        </div>
      </div>

    </div>


    </div>
    <!--<div v-if="!showing">
      Varukorg ({{count()}})
    </div>-->
    <div class="cart-trigger" id="cart-trigger" @click="toggle()"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import API from '@/classes/API';
import PriceView from '@/components/components/PriceView';

export default {
  props: {
    showFromStart: {
      default: false,
    },
    useStorage: {
      default: true,
    },
    order: {
      default: () => {},
    },
  },
  components: {
    PriceView,
  },
  data() {
    return {
      showing: false,
    };
  },
  computed: {
    ...mapGetters([
      'cart',
    ]),
    localCart() {
      if (this.useStorage) {
        return this.cart;
      }
      return this.order;
    },
    hasDelivery() {
      let delivery = false;

      // this.localCart.skipasses.forEach((a) => {
      //   if (a.confirmed) {
      //     if (a.delivery || a.deliveryType === 'delivery' || a.delivery_type === 'delivery') {
      //       delivery = true;
      //     }
      //   }
      // });

      this.localCart.rentals.forEach((a) => {
        if (a.confirmed) {
          if (a.delivery || a.deliveryType === 'delivery') {
            delivery = true;
          }
        }
      });

      return delivery;
    },
  },
  mounted() {
    if (this.showFromStart) {
      this.showing = true;
    }
  },
  methods: {
    count() {
      const accomodations = this.localCart.accomodations.reduce((a, b) =>
        (b.confirmed ? a + 1 : a), 0,
      );
      const skipasses = this.localCart.skipasses.reduce((a, b) =>
        (b.confirmed ? a
          + this.number(b.adults)
          + this.number(b.youths)
          + this.number(b.children)
          : a), 0,
      );

      return accomodations + skipasses;
    },
    accomodationSkipassDiscountedPrice(skipass, ageSingular, agePlural) {
      const lidProperty = `${ageSingular}Lid`;
      const priceProperty = ageSingular === 'child' ? 'childPrice' : `${agePlural}Price`;
      const quantity = this.number(skipass[agePlural]);
      const lid = this.number(skipass[lidProperty]);
      let discountedPrice = skipass.discountedPrices && skipass.discountedPrices[lid];

      if (Number.isInteger(discountedPrice) || ageSingular === 'child') {
        discountedPrice += 55; // TODO: Remove this when we have a better solution
      }

      if (discountedPrice) {
        return quantity * discountedPrice;
      }

      return quantity * skipass[priceProperty];
    },
    accomodationDiscountedPrice(accomodation) {
      const quantity = this.number(accomodation.quantity);

      if (Number.isInteger(accomodation.discountedPrice)) {
        return accomodation.discountedPrice * quantity;
      }

      return accomodation.price * quantity;
    },
    addonDiscountedPrice(addon) {
      const quantity = this.number(addon.quantity);

      if (Number.isInteger(addon.discountedPrice)) {
        return quantity * addon.discountedPrice;
      }

      return quantity * addon.price;
    },
    totalPrice(discounted = false) {
      const accomodations = this.localCart.accomodations.reduce((a, b) => {
        if (this.localCart.campaignCode && discounted) {
          return (b.confirmed ? a + (b.discountedPrice * this.number(b.quantity)) : a);
        }
        return (b.confirmed ? a + (b.price * this.number(b.quantity)) : a);
      }, 0);
      const addons = this.localCart.addons.reduce((a, b) => {
        if (b.confirmed) {
          if (b.discount && b.discount.type === 'percentage') {
            return a + ((b.price * (b.discount.amount / 100)) * this.number(b.quantity));
          }
          if (this.localCart.campaignCode && discounted) {
            return a + this.addonDiscountedPrice(b);
          }
          return a + (b.price * this.number(b.quantity));
        }
        return a;
      }, 0);
      const skipasses = this.localCart.skipasses.reduce((a, b) => {
        if (b.confirmed) {
          if (b.type === 'SKIPASS-ACCO') {
            if (this.localCart.campaignCode && discounted) {
              const adults = this.accomodationSkipassDiscountedPrice(b, 'adult', 'adults');
              const youths = this.accomodationSkipassDiscountedPrice(b, 'youth', 'youths');
              const children = this.accomodationSkipassDiscountedPrice(b, 'child', 'children');
              const seniors = this.accomodationSkipassDiscountedPrice(b, 'senior', 'seniors');
              return a + adults + youths + children + seniors;
            }

            const adults = this.number(b.adults) * this.number(b.adultsPrice);
            const youths = this.number(b.youths) * this.number(b.youthsPrice);
            const children = this.number(b.children) * this.number(b.childrenPrice);
            const seniors = this.number(b.seniors) * this.number(b.seniorsPrice);
            return a + adults + youths + children + seniors;
          }
          const price = this.number(discounted && Number.isInteger(b.discountedPrice)
            ? b.discountedPrice : b.price);
          return a + (this.number(b.quantity) *
            (price + (b.keycardPrice ? this.number(b.keycardPrice) : 0)));
        }
        return a;
      }, 0);
      let rentals = 0;

      if (this.SITE_CONFIG.rental.insurance_per_product) {
        if (this.localCart.campaignCode) {
          rentals = this.localCart.rentals.reduce((a, b) => (b.confirmed ?
            a + (this.getProductPrice(b, discounted) * this.number(b.quantity)) : a), 0,
            );
        } else {
          rentals = this.localCart.rentals.reduce((a, b) =>
            (b.confirmed ? a + (b.price * this.number(b.quantity)) : a), 0,
            );
        }
      } else {
        rentals = this.localCart.rentals.reduce((a, b) =>
          (b.confirmed ? a + ((b.price * this.number(b.quantity))
          + (b.insurance ? b.insuranceSum : 0)) : a), 0,
        );
      }
      const skischools = this.localCart.skischools.reduce((a, b) =>
        (a + (b.price * this.number(b.quantity))), 0,
      );
      const activities = (this.localCart.activities || []).reduce((a, b) =>
        (a + (b.price * this.number(b.quantity))), 0,
      );
      const products = (this.localCart.products || []).reduce((a, b) =>
        (a + (b.price * this.number(b.quantity))), 0,
      );

      return accomodations + skipasses + addons + rentals + skischools + activities + products;
    },
    getProductPrice(p, discounted = false) { // eslint-disable-line
      let price = 0;
      const days = p.days;

      // eslint-disable-next-line
      for (let i in p.products) {
        const priceToAdd = (discounted && Number.isInteger(p.products[i].discountedPrice))
          ? p.products[i].discountedPrice
          : this.getNestedProductPrice(days, p.products[i], p.insurance);
        price += priceToAdd;
      }

      // eslint-disable-next-line
      for (let i in p.addons) {
        const priceToAdd = (discounted && Number.isInteger(p.addons[i].discountedPrice))
          ? p.addons[i].discountedPrice
          : this.getNestedProductPrice(days, p.addons[i], p.insurance);
        price += priceToAdd;
      }

      return price;
    },
    getNestedProductPrice(days, product, insurance) { // eslint-disable-line
      if (insurance) {
        return product[`price_insurance_${days}`] || 0;
      }

      return product[`price_${days}`] || 0;
    },
    ...mapMutations([
      'removeCartItem',
      'openModal',
      'closeModal',
    ]),
    cancel(obj) {
      const $this = this;
      this.openModal(['GeneralModal', {
        content: this.$i18n.t('general.unbook-question-text'),
        no: $this.closeModal,
        yes: async () => {
          $this.$emit('loading', true);
          const { data } = await API.post(`/payments/cancel-order-line/${this.$route.params.bookingNumber}/${obj.row}`);
          $this.$emit('loadingcomplete', true);
          $this.$emit('changed', true);
          $this.closeModal();
          return data;
        },
      }]);
    },
    localRemoveCartItem(obj) {
      let content = this.$i18n.t('general.remove-row-question-text');
      if (obj.type === 'accomodations') {
        content = this.$i18n.t('general.remove-row-question-text-accomodation');
      }

      const $this = this;
      this.openModal(['GeneralModal', {
        content,
        no: $this.closeModal,
        yes: async () => {
          const aIndex = obj.index;

          // Special handling when skipasses are removed
          if (obj.type === 'skipasses' && obj.age) {
            $this.cart.skipasses[aIndex][obj.age] = 0;
            $this.cart.skipasses[aIndex][`hide${obj.age}`] = true;
            if (
              $this.cart.skipasses[aIndex].adults
              || $this.cart.skipasses[aIndex].youths
              || $this.cart.skipasses[aIndex].children
            ) {
              $this.closeModal();
              return;
            }
          }

          if (obj.type === 'accomodations') {
            let index = $this.cart.addons.length;
            while (index > 0) {
              index -= 1;
              if ($this.cart.addons[index].belongsTo === aIndex) {
                $this.removeCartItem({ type: 'addons', index });
                console.log('Removing addon with index', index);
              } else if ($this.cart.addons[index].belongsTo > aIndex) {
                $this.cart.addons[index].belongsTo -= 1;
                console.log('Lowering addon index on', index);
              }
            }

            index = $this.cart.skipasses.length;
            while (index > 0) {
              index -= 1;
              if ($this.cart.skipasses[index].belongsTo === aIndex) {
                $this.removeCartItem({ type: 'skipasses', index });
                console.log('Removing skipass with index', index);
              } else if ($this.cart.skipasses[index].belongsTo > aIndex
                && $this.cart.skipasses[index].belongsTo !== -1) {
                $this.cart.skipasses[index].belongsTo -= 1;
                console.log('Lowering skipass index on', index);
              }
            }

            $this.cart.rentals.forEach((rental, i) => {
              if ($this.cart.rentals[i].belongsTo === aIndex) {
                $this.cart.rentals[i].belongsTo = -1;
                console.log('Setting rental belongsto to -1, index', index);
              } else if ($this.cart.rentals[index].belongsTo > aIndex) {
                $this.cart.rentals[index].belongsTo -= 1;
                console.log('Lowering rental index on', index);
              }
            });

            // Remove locking
            const pId = $this.cart.accomodations[aIndex].poolLid;
            const uId = $this.cart.accomodations[aIndex].unitLid;
            const startDate = $this.cart.accomodations[aIndex].period.date_arrival;
            const endDate = $this.cart.accomodations[aIndex].period.date_departure;
            const code = $this.$store.state.lockingCode;
            const { data } = await API.post(`cancel-reservation/${code}/${pId}/${uId}/${startDate}/${endDate}`);
            console.log(data);
          }

          if (obj.type === 'skischools') {
            const school = $this.cart.skischools[obj.index];
            await API.get(`/skischool/release-reservation/${school.activity_lid}/${this.$store.state.lockingCode}`);
          }

          $this.removeCartItem(obj);

          const accomodationCount = $this.cart.accomodations.filter(a => a.confirmed).length;
          $this.$store.state.lockingActive = !!accomodationCount;

          $this.closeModal();
        },
      }]);
    },
    edit(obj) {
      if (obj.type === 'accomodations') {
        this.$router.push({ name: 'confirm-accomodation', query: { no: obj.index } });
      }
      if (obj.type === 'addons') {
        this.$router.push({ name: 'addons', query: { no: obj.index } });
      }
      if (obj.type === 'skirentals') {
        this.$router.push({ name: 'ski rental overview' });
      }
      this.showing = false;
    },
    moment(date, format) {
      const string = moment(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggle(setTo) {
      if (typeof setTo !== 'undefined') {
        this.showing = setTo;
      } else {
        this.showing = !this.showing;
      }

      this.updateIconWrapper();

      if (!this.showFromStart) {
        this.updateBody();
      }
    },
    updateBody() {
      if (this.showing) {
        document.body.classList.add('cart-opened');
        document.body.classList.add('cart-opened--with-background');
        setTimeout(() => {
          document.addEventListener('click', this.documentClick);
        }, 1);
      } else {
        document.body.classList.remove('cart-opened');
        document.body.classList.remove('cart-opened--with-background');
        document.removeEventListener('click', this.documentClick);
      }
    },
    documentClick(e) {
      if (e.target !== this.$el && !this.$el.contains(e.target)) {
        e.stopPropagation();
        this.toggle();
      }
    },
    updateIconWrapper() {
      if (this.showing) {
        document.getElementById('cart-icon-wrapper').className = 'active';
      } else {
        document.getElementById('cart-icon-wrapper').className = '';
      }
    },
    closeCart() {
      this.toggle(false);
    },
    pay() {
      this.toggle(false);
      this.$router.push({ name: 'shopping cart' });
    },
    bookAddon(row) {
      this.$store.state.cart.addToOrder = {
        number: this.order.resvid,
        numeric: this.order.headlid,
        accomodationRow: row.row,
        accomodationName: row.name,
        accomodationDateArrival: row.arrival,
        accomodationDateDeparture: row.departure,
        accomodationGroup: row.group,
      };

      this.$router.push({
        name: 'addons extra',
        query: {
          pool: row.pool,
          unit: row.unit,
          arrival: row.arrival,
          departure: row.departure,
          name: row.name,
          adults: parseInt(row.adults, 10),
          youths: parseInt(row.youths, 10),
          children: parseInt(row.children, 10),
          seniors: parseInt(row.seniors, 10) || 0,
        },
      });
    },
    rowInfo(row) {
      const $this = this;
      const people = `<p><b>Åkare:</b> ${row.people_as_string}</p>`;
      const time = `<p><b>Tid:</b> ${row.start_time} – ${row.end_time}</p>`;
      const arrival = moment(row.date_arrival).format('D MMMM');
      const departure = moment(row.date_departure).format('D MMMM');
      const arrivalDay = moment(row.date_arrival).format('dddd');
      const departureDay = moment(row.date_departure).format('dddd');
      let dates = `<p><b>Datum:</b> ${arrival} – ${departure} (${arrivalDay} – ${departureDay})</p>`;

      if (arrival === departure) {
        dates = `<p><b>Datum:</b> ${arrival} (${arrivalDay})</p>`;
      }

      const place = `<p><b>Plats:</b> ${row.location}</p>`;

      const description = row.description ? `<p>${row.description}</p>` : '';

      this.openModal(['GeneralModal', {
        zIndex: 20,
        title: row.name,
        content: (
          `<p>${description}</p>${place}${people}${dates}${time}`
        ),
        buttons: [
          {
            title: 'Stäng',
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    removeDelivery() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: 'Hämta själv',
        content: 'Vill du ta bort utkörning för din bokning och hämta själv istället?',
        buttons: [
          {
            title: 'Jag vill hämta själv',
            class: 'small',
            click: () => {
              $this.$store.state.cart.deliveryTo = {};
              /*eslint-disable */
              for (let i in $this.$store.state.cart.rentals) {
                $this.$store.state.cart.rentals[i].delivery = false;
                $this.$store.state.cart.rentals[i].site = null;
              }
              for (let i in $this.$store.state.cart.skipasses) {
                $this.$store.state.cart.skipasses[i].delivery_type = 'pickup';
                $this.$store.state.cart.skipasses[i].deliveryType = 'pickup';
                $this.$store.state.cart.skipasses[i].site = null;
              }
              /*eslint-enable */
              $this.closeModal();
              window.location.reload();
            },
          },
          {
            title: this.$i18n.t('general.go-back'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

local-input()
  width: 2.1em !important;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: #fff;
  border: solid 1px #bfd9e1;
  text-align: center;

.cart-trigger
  height 0
  width 0
  position fixed
  left -1px
  top -1px
.cart
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.08);
  position absolute
  top 0
  right 0
  background-color white
  height 0
  width 0
  z-index 11
  &.from-start
    z-index 1
  &.showing
    width 100%
    top 65px
    height auto
header
  padding: 9px 23px 5px;
  background-color: #005580;
  display flex
  justify-content: space-between
  .col
    color white
    font-family: Interstate;
    font-size: 16px;
    font-weight: bold;
    width 20%
    united-heavy()
    +max-mobile()
      width 100%
    &.type
      width 24%
      padding-right 30px
    &.date
      width 25%
      padding-right 30px
      +max-mobile()
        display none
    &.actions
      width 20%
      +max-mobile()
        display none
    &.count
      width 5%
      +max-mobile()
        display none
    &.price
      text-align right
      width 15%
      padding-right 30px
      +max-mobile()
        display none
    &.trash
      width 5%
  &.top-header
    background-color: #deebf0;
    border-top-left-radius: 4px;
    box-shadow: none;
    border-top-left-radius: 4px;
    +max-mobile()
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    .col
      color: #005580;
      font-family: Interstate;
      font-size: 13px;
      font-weight: bold;
.row
  padding 6px 23px
  display flex
  justify-content: space-between
  background-color white
  &.cancelled
    disabled()
    text-decoration: line-through;
  &:nth-child(even)
    background-color: #f9f9f9;
  +max-mobile()
    flex-wrap wrap
    padding-top 12px
    padding-bottom 15px
  button
  &.white
    margin-right: 10px
  .col
    font-family: Interstate;
    font-size: 13px;
    font-weight: normal;
    width 20%
    color: #262626;
    &.type
      font-weight bold
      width 25%
      padding-right 30px
      position: relative
      top: 5px
      order 1
      +max-mobile()
        order 1
        width 70%
        font-size 13px
        margin-bottom: 10px
      ul
        padding-left 0px
        margin-top: 4px
      .sub
        font-weight 300
        padding-left 0
        line-height 1.35em
        margin-bottom: 4px
        padding-left: 0px
        font-size: 12px
    &.date
      width 30%
      padding-right 30px
      font-size: 12px
      padding-top: 4px
      order 2
      +max-mobile()
        width 100%
        order 4
      .icon
        position: relative
        top -2px
        margin-right: 4px
    &.actions
      width 20%
      text-align right
      padding-right 20px
      order 4
      +max-mobile()
        width 100%
        order 5
        display flex
        justify-content: space-between;
        padding-right 0
        margin-top 5px
        margin-bottom 5px
        & > *
          width 45%
          margin-left 0
          margin-right 0
    &.count
      width 5%
      order 3
      .label
        display none
        +max-mobile()
          display: inline-block;
          font-weight bold
      input[type="number"]
        local-input()
      +max-mobile()
        width 100%
        display block
        order 6
      &.hide-on-small
        +max-mobile()
          display: none !important
    &.price
      width 15%
      font-weight bold
      text-align right
      padding-right 30px
      order 5
      +max-mobile()
        width 20%
        font-size 12px
        order 2
        &.has-discount
          width: 30%
    &.trash
      width 5%
      order 6
      +max-mobile()
        width 10%
        order 6
    &.right
      width 100%
      text-align right
footer
  padding 12px 99px 8px 23px
  background-color #deebf0
  font-weight bold
  display flex
  color #005580
  justify-content: space-between
  border-bottom-left-radius: 4px;
  box-shadow: none;
  border-bottom-right-radius: 4px;
  b
    font-size: 22px;
    font-weight: 900;
    font-family  'United Serif Cond'
    font-weight 900
.thin
  font-weight: 100
  font-style: italic
  font-size 0.8em
  line-height: 1.5em
  padding: 0.5em 0
.discount
  font-weight: 100;

.empty-cart
  font-size: 16px
  text-align: center;

.no-bold
  font-weight: normal
</style>



// WEBPACK FOOTER //
// Cart.vue?44c2e0e0